module.exports = __webpack_public_path__ + "img/nav-designer.6db9a47.webp";